import { Injectable } from '@angular/core';
import { HttpRequestHandler } from '../../../core/models/http-model';
import { HttpService } from '../../../core/services/http.service';
import { AlertService } from '../../../shared/services/alert.service';
import { environment } from '../../../../environments/environment';

const HEADERS = {};

@Injectable()
export class AdminNotificationsService {

  static ENV = environment;

  constructor(
    private httpProvider: HttpService,
    private _alertService: AlertService,
  ) {
    HEADERS['Content-Type'] = 'application/json';
    HEADERS['Accept'] = 'application/json, text/plain, */*';
  }

  public getNotifications(httpRequesthandler: HttpRequestHandler) {
    let urlNotifications = AdminNotificationsService.ENV.environment.NOTIFICATIONS;
    httpRequesthandler.headers = HEADERS;
    this.httpProvider.get( urlNotifications.adminotifications, httpRequesthandler);
  }

  public updateNotification(id, data, httpRequesthandler : HttpRequestHandler){
    let urlNotifications = AdminNotificationsService.ENV.environment.NOTIFICATIONS;
    httpRequesthandler.headers = HEADERS;
    this.httpProvider.put(`${urlNotifications.adminotifications}/${id}`, data, httpRequesthandler);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/admin/admin-notifications.service.ts